import { Link } from "react-router-dom";
import { useEffect, useState } from 'react';
import { FaRegStar } from "react-icons/fa";
import icons from "../../../database/icone";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import axios from "axios";
import { useStateContext } from "../../../Context/ContextProvider";
import ModalEtp from "../ModalCoursEtp/ModalCoursEtp";
import { useSearch } from "../../../Context/SearchContext";


export default function EtpCatalogue() {

    const [isFormOpen, setIsFormOpen] = useState(false);
    const [userType, setUserType] = useState(null);
    const [onlineModules, setOnlineModules] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    //zone de recherche
    const { searchTerm } = useSearch();

    const { ModuleComptesEtp } = useStateContext();

    //bg couleur selon le niveau
    const levelColors = {
        'Intermédiaire': '#ECFCCB',
        'MasterClass': '#FFE4E6',
        'Fondamentaux': '#CCFBF1',
        'Avancée': '#DBEAFE',
    };
    // couleur text selon le niveau
    const textColors = {
        'Intermédiaire': '#3F6253',
        'MasterClass': '#9F1276',
        'Fondamentaux': '#2388B6',
        'Avancée': '#4F40BC'
    }

    //const baseURL = "https://formafusionmg.ams3.cdn.digitaloceanspaces.com/formafusionmg/img/modules/";
    const baseURL = `${process.env.REACT_APP_URL_IMAGE}/`;

    const fetchModules = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const response = await axios.get('https://catalogue.mg.formafusion.io/api/entreprise/modules', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            // Récupération des modules en préparation depuis l'API
            const onlineData = response.data.onlineModules || [];
            setOnlineModules(onlineData);

        } catch (error) {
            console.error("Erreur lors de la récupération:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchModules();
    }, []);

    // const handleModuleAdded = (newModule) => {
    //     const stored = JSON.parse(localStorage.getItem("onlineModules")) || [];
    //     const updatedStored = [...stored];

    //     // Chercher le domaine correspondant
    //     const domainIndex = updatedStored.findIndex(d => d.domaine === newModule.domaine);
    //     if (domainIndex !== -1) {
    //         updatedStored[domainIndex].modules.unshift(newModule);
    //         updatedStored[domainIndex].count_module += 1;
    //     } else {
    //         updatedStored.unshift({
    //             domaine: newModule.domaine,
    //             modules: [newModule],
    //             count_module: 1
    //         });
    //     }

    //     setOnlineModules(updatedStored);
    //     localStorage.setItem("onlineModules", JSON.stringify(updatedStored));
    //     fetchModules();
    // };

    //changement de status
    const updateStatus = async (id, action) => {
        console.log("id:", id);
        console.log("action:", action);
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            console.log("Token utilisé :", token);
            const response = await axios.patch(`https://catalogue.mg.formafusion.io/api/entreprise/modules/${id}/${action}`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            if (response.status === 200) {
                setOnlineModules(prev =>
                    prev.map(domaine => ({
                        ...domaine,
                        modules: domaine.modules.filter(mod => mod.idModule !== id)
                    })).filter(domaine => domaine.modules.length > 0)
                );
                toast.success("Mise à jour avec succès");
                ModuleComptesEtp();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("une erreur est survenue");
        }

    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="flex flex-col items-center justify-start w-full max-w-screen-xl min-h-screen mx-auto space-y-2 p-2 mt-10 sm:mt-14 lg:mt-16">
                {/* Modules disponibles */}
                <div>
                    {isLoading ? (
                        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-50 flex items-center justify-center px-4">
                            <div className="text-center">
                                <p className="text-gray-700 text-lg sm:text-xl font-semibold">veuillez patienter...</p>
                                <div className="flex justify-center space-x-2 mt-2">
                                    <div className="w-3 h-3 animate-bounce">📚</div>
                                    <div className="w-3 h-3 animate-bounce [animation-delay:-0.2s]">📚</div>
                                    <div className="w-3 h-3 animate-bounce [animation-delay:-0.4s]">📚</div>
                                </div>
                            </div>
                        </div>
                    ) : onlineModules && onlineModules.length > 0 ? (
                        onlineModules
                            .filter(domaineItem => {
                                const domaineName = domaineItem.domaine || '';
                                return domaineName.toLowerCase().includes(searchTerm.toLowerCase());
                            })
                            .map((domaineItem, index) => (
                                <div key={index} className="mb-8">
                                    {/* En-tête du domaine - Texte réduit sur mobile */}
                                    <div className="flex justify-between items-center w-full p-2 text-lg sm:text-xl font-semibold bg-slate-400 rounded-lg h-10 mt-5">
                                        <h1 className="text-xs sm:text-sm md:text-[15px] text-slate-950 truncate">
                                            {domaineItem.domaine || 'Domaine inconnu'}
                                        </h1>
                                        <h2 className="bg-white rounded-xl w-16 sm:w-20 h-6 sm:h-7 text-center text-xs sm:text-[13px] flex items-center justify-center">
                                            {domaineItem.modules?.length || 0} module{domaineItem.modules?.length !== 1 ? 's' : ''}
                                        </h2>
                                    </div>

                                    {/* Grille responsive - 1 colonne mobile, 2 tablettes, 3+ desktop */}
                                    <ul className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 lg:gap-12 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-4">
                                        {domaineItem.modules
                                            ?.filter((module) => {
                                                const name = module.module_name || module.name || '';
                                                return name.toLowerCase().includes(searchTerm.toLowerCase());
                                            })
                                            .map((module) => {
                                                const name = module.module_name || module.name || 'Nom inconnu';
                                                const image = module.module_image || 'default.jpg';
                                                const level = module.module_level_name || 'Niveau inconnu';
                                                const dureeJ = module.module_dureeJ ?? module.dureeJ ?? 0;
                                                const dureeH = module.module_dureeH ?? module.dureeH ?? 0;
                                                const prix = module.module_price ?? module.prix ?? 0;
                                                const formed = module.totalFormed || 0;
                                                const moduleId = module.idModule;

                                                return (
                                                    <li key={moduleId} className="w-full col-span-1 bg-white shadow-lg sm:shadow-xl rounded-lg sm:rounded-xl p-3 sm:p-4 border-gray-200 border-2 group">
                                                        <div className="flex gap-4 sm:gap-7">
                                                            <figure className="h-[70px] sm:h-[80px] w-40 bg-slate-100 rounded-md overflow-hidden mb-2">
                                                                <img
                                                                    src={`${baseURL}${image}`}
                                                                    alt="Illustration"
                                                                    className="w-full h-full object-cover"
                                                                />
                                                            </figure>
                                                            <p
                                                                className=" font-bold text-[10px] sm:text-[12px] mb-1 px-2 py-0 rounded-lg h-6 flex items-center"
                                                                style={{ backgroundColor: levelColors[level], color: textColors[level] }} // couleur par défaut
                                                            >
                                                                {level}
                                                            </p>
                                                        </div>

                                                        <h2 className="text-xs sm:text-[12px] font-semibold text-[#333] mb-1 truncate">{name}</h2>

                                                        <div className="flex items-center gap-1 mb-2 text-yellow-400 text-xs sm:text-sm">
                                                            <FaRegStar /><FaRegStar /><FaRegStar /><FaRegStar /><FaRegStar />
                                                        </div>

                                                        <div className="grid grid-cols-2 gap-2 mb-1">
                                                            <p className="text-slate-500 inline-flex items-center gap-1 text-xs sm:text-sm">
                                                                <icons.clock className="text-xs sm:text-sm" /> {dureeJ} jours ({dureeH}h)
                                                            </p>
                                                            {/* <p className="text-slate-500 text-xs sm:text-sm text-right">Ar {parseInt(prix)}</p> */}
                                                        </div>

                                                        <div className="flex justify-between">
                                                            <p className="text-slate-500 inline-flex items-center gap-1 text-xs sm:text-sm">
                                                                <icons.users /> {formed} formé(s)
                                                            </p>
                                                        </div>

                                                        <div className="flex items-center justify-end border-t pt-2 gap-2 sm:gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ">
                                                            <Link
                                                                to={`/etp/catalogue/${moduleId}/edit`}
                                                                className="btn btn-ghost btn-sm"
                                                                title="Voir les détails"
                                                                state={{ fromStatus: 'online' }}
                                                            >
                                                                <icons.eye className="text-xs sm:text-sm" />
                                                            </Link>
                                                            <button className="btn btn-ghost btn-sm" title="Mettre en préparation" onClick={() => updateStatus(module.idModule, 'offline')}>
                                                                <icons.settings className="text-xs sm:text-sm" />
                                                            </button>
                                                            <button className="btn btn-ghost btn-sm" title="Mettre en corbeille" onClick={() => updateStatus(module.idModule, 'trash')}>
                                                                <icons.trash className="text-xs sm:text-sm" />
                                                            </button>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            ))
                    ) : (
                        <h1 className="text-center mt-10 text-gray-500">Aucun module disponible </h1>
                    )}
                </div>

            </div>
        </>
    );
}